import { render, staticRenderFns } from "./my_report.vue?vue&type=template&id=723c8f24&scoped=true&"
import script from "./my_report.vue?vue&type=script&lang=js&"
export * from "./my_report.vue?vue&type=script&lang=js&"
import style0 from "./my_report.vue?vue&type=style&index=0&id=723c8f24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723c8f24",
  null
  
)

export default component.exports